import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hrms41e/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hrms41e/columnsLabels')
  },
  getIndex (searchParams) {
    let sendParams = {}
    sendParams = {
      p_dteappoist: (typeof searchParams.dteappoist !== 'undefined' ? searchParams.dteappoist : ''),
      p_dteappoien: (typeof searchParams.dteappoien !== 'undefined' ? searchParams.dteappoien : ''),
      p_numapplst: (typeof searchParams.numapplst !== 'undefined' ? searchParams.numapplst : ''),
      p_numapplen: (typeof searchParams.numapplen !== 'undefined' ? searchParams.numapplen : '')
    }
    if (isMock) return generator(mocker.index())
    return instance().get(endpoint + '/hrms41e/index', { params: sendParams })
  },
  getDetail (searchParams) {
    let sendParams = {}
    sendParams = {
      p_numreqrq: searchParams.p_numreqrq
    }
    let param = searchParams.p_numappl + '/' + searchParams.p_codposrq + '/' + searchParams.p_numapseq
    if (isMock) return generator(mocker.detail())
    return instance().get(endpoint + '/hrms41e/detail/' + param, { params: sendParams })
  },
  postSaveDetailTab1 ({ searchIndex, indexSelected, detailTab1 }) {
    let sendParams = {
      param_json: JSON.stringify({
        codform: detailTab1.codform,
        codposrq: indexSelected.codposrq,
        dteappoi: indexSelected.dteappoi,
        numappl: indexSelected.numappl,
        numreqrq: indexSelected.numreqrq,
        numapseq: indexSelected.numapseq,
        detail: detailTab1.detail,
        table1: detailTab1.table1
      })
    }
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hrms41e/detailTab1Save', sendParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms41e/index.js